export class BackupZeroEtlAccessConfiguration {
    'aws';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "BackupZeroEtlAwsAccessConfiguration",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlAccessConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
